import { getActiveEnvProfile } from "@/utils/utils";
import { useIsSystemAdmin } from "../auth/hooks";

// Overviews and the business coefficients on the contract detail are not released yet, so on production only system
// admins see them
export const useIsOverviewsEnabled = () => {
  const isSystemAdmin = useIsSystemAdmin();

  return getActiveEnvProfile() !== "prod" || !!isSystemAdmin;
};
